import React from 'react';
import CreativeView from './components/creative';

function App() {
  return (
    <div>
      {/* <Router>
        <Routes>
          <Route path='/' element={<CreativeView />} />
          <Route path='/portal' element={<PortalView />} />
        </Routes>
      </Router> */}
      <CreativeView />
    </div>
  );
}

export default App;
